// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen{.print_page[data-v-853ea2f2]{padding:2rem 1rem}}", "",{"version":3,"sources":["webpack://./resources/client/layouts/page/LayoutPrintPage.vue"],"names":[],"mappings":"AACA,cACE,6BACE,iBAAF,CACF","sourcesContent":["\n@media screen {\n  .print_page {\n    padding: 2rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
